import { render, staticRenderFns } from "./template_event.vue?vue&type=template&id=37c77ae9&"
import script from "./template_event.vue?vue&type=script&lang=js&"
export * from "./template_event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports